import { PlusOutlined } from "@ant-design/icons";
import { Calendar, Checkbox, ConfigProvider } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import dayLocaleData from "dayjs/plugin/localeData";
import React, { useState } from "react";
import { Divider, LeftBtn, RightBtn } from "../utils/icons";
dayjs.extend(dayLocaleData);

const CalenderCom = ({
  toggleModal,
  filter,
  handleCheckboxChange,
  checkboxStates,
}) => {
  const [date, setDate] = useState(dayjs());

  const onPanelChange = (value, mode) => {
    console.log(value.format("YYYY-MM-DD"), mode);
  };

  return (
    <div className="p-5 flex flex-col gap-5 justify-center items-center bg-pureWhite rounded-3xl shadow-[0px_4px_18px_0px_#4B465C1A] w-full">
      <button
        onClick={() => toggleModal(true)}
        className="bg-sandAgainBtn w-full rounded-3xl p-2 text-pureWhite flex justify-center items-center"
      >
        <PlusOutlined /> Add Event
      </button>
      <Divider />
      <ConfigProvider
        theme={{
          components: {
            Calendar: {
              colorPrimary: "#FF6B38",
            },
          },
        }}
      >
        <Calendar
          value={date}
          fullscreen={false}
          headerRender={({ value, type, onChange, onTypeChange }) => {
            const year = value.year();
            const monthText = value.format("MMM");
            return (
              <div className="flex justify-between p-3">
                <h1 className="font-semibold text-lg">{`${year}  ${monthText}`}</h1>
                <div className="space-x-3">
                  <button
                    className="text-gray-600"
                    onClick={() => setDate(date.add(-1, "months"))}
                  >
                    <LeftBtn />
                  </button>
                  <button
                    className="text-gray-600"
                    onClick={() => setDate(date.add(1, "months"))}
                  >
                    <RightBtn />
                  </button>
                </div>
              </div>
            );
          }}
          onPanelChange={onPanelChange}
        />
      </ConfigProvider>
      <Divider />
      <div className="flex flex-col w-full gap-2">
        <h1 className="font-semibold text-lg">Filter</h1>
        {filter.map((items, i) => {
          return (
            <ConfigProvider
              key={i}
              theme={{
                components: {
                  Checkbox: {
                    colorPrimary: items.color,
                    colorPrimaryHover: items.color,
                  },
                },
              }}
            >
              <Checkbox
                value={items.title}
                className="w-full font-semibold"
                disabled={
                  checkboxStates[0] === "View All" && items.title !== "View All"
                }
                checked={checkboxStates.includes(items.title)}
                onChange={(e) =>
                  handleCheckboxChange(items.title, e.target.checked)
                }
              >
                {items.title}
              </Checkbox>
            </ConfigProvider>
          );
        })}
      </div>
      <Divider />
    </div>
  );
};

export default CalenderCom;
